import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import "./Header.styles.css";
import logo from "../../assets/images/flight/Trianfly Tm.png";
import blackLogo from "../../assets/images/flight/LogoBlack.png";
import support from "../../assets/images/flight/support (1).png";
import direction from "../../assets/images/flight/direction.png";
import { phoneNum } from "../../utils/globalVars";

const Header = () => {
  let location = useLocation();


  const isMobile = window.innerWidth <= 767;

  const [toggle, setToggle] = useState(false);
  const toggleMenu = () => {
    if (toggle === false) {
      setToggle(true);
    } else {
      setToggle(false)
    }
  }
  return (
    <>
      <header>
        <div className="container">
          <div className="flex align-center space-between">
            <div className="site-logo" style={{ width: "150px" }}>
              <Link to="/">
                {location.pathname == "/" ? <img src={logo} alt="Trian Fly" /> : <img src={blackLogo} alt="Trian Fly" />}
              </Link>
            </div>
            <nav>
              <div className="menu-wrapper">
                <div className={`navBarmenu menu ${(toggle === false) ? `` : `active`}`}>
                  <ul>
                    <li>
                      <Link style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} to="/">Home</Link>
                    </li>
                    <li>
                      <Link style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} to="/packages">Packages</Link>
                    </li>
                    <li>
                      <Link style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <a style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} href={`tel:${phoneNum.label}`}>
                        <span>
                          <i className="fa fa-headphones" aria-hidden="true"></i>
                        </span>
                        Support
                      </a>
                    </li>
                    <li>
                      <a style={{ color: useLocation().pathname == "/" ? isMobile ? "black" : "white" : "black" }} href={`tel:${phoneNum.label}`}>
                        <span>
                          <i className="fa fa-phone" aria-hidden="true"></i>
                        </span>
                        {phoneNum.label}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mobile-view">
                  <div className="contact-no">
                    <a style={{ color: useLocation().pathname == "/" ? "white" : "black" }} href={`tel:${phoneNum.label}`}>
                      <span>
                        <i className="fa fa-phone" aria-hidden="true"></i>
                      </span>
                      {phoneNum.label}
                    </a>
                  </div>
                  <div className="toggle-menu" onClick={() => toggleMenu()}>
                    <i class="fa-solid fa-bars"></i>
                  </div>
                </div>
              </div>

            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
